/* ============================================================
   MID · SIATRA — Shopify AJAX cart drawer (vanilla)
   Powers add-to-cart, slide-in drawer, qty change, remove.
   Backed by Shopify Cart AJAX API (/cart/add.js, /cart.js,
   /cart/change.js). Guards on missing nodes so it is safe to
   load on pages without the cart chrome (e.g. home).
   ============================================================ */
(function () {
  "use strict";

  function money(cents) {
    // Shopify amounts are integer cents. Format as RD$ 1,234.
    var n = (cents / 100);
    return "RD$ " + n.toLocaleString("en-US", { minimumFractionDigits: 0, maximumFractionDigits: 2 });
  }

  function el(id) { return document.getElementById(id); }
  function $all(sel, root) { return [].slice.call((root || document).querySelectorAll(sel)); }

  /* ---------- drawer open/close ---------- */
  function openCart() {
    var s = el("cartScrim"), d = el("cart");
    if (s) s.classList.add("is-open");
    if (d) d.classList.add("is-open");
    document.body.style.overflow = "hidden";
  }
  function closeCart() {
    var s = el("cartScrim"), d = el("cart");
    if (s) s.classList.remove("is-open");
    if (d) d.classList.remove("is-open");
    document.body.style.overflow = "";
  }

  /* ---------- render from /cart.js ---------- */
  function syncCount(count) {
    $all(".cart-count").forEach(function (n) {
      n.textContent = count;
      n.classList.toggle("on", count > 0);
    });
  }

  function renderCart(cart) {
    syncCount(cart.item_count);
    var list = el("cartList");
    var foot = el("cartFoot");
    if (!list) return;

    if (!cart.items.length) {
      list.innerHTML = '<div class="cart__empty"><span class="s-icon">shopping_bag</span><div>Tu selección está vacía.<br>Explora la tienda y añade piezas.</div><a class="s-btn s-btn--ghost" href="/collections/all">Ir a la tienda</a></div>';
      if (foot) foot.style.display = "none";
      return;
    }

    list.innerHTML = cart.items.map(function (it) {
      var img = it.image ? it.image.replace(/(\.[^.]+)(\?.*)?$/, "_120x150_crop_center$1$2") : "";
      var variant = (it.variant_title && it.variant_title !== "Default Title") ? (" · " + it.variant_title) : "";
      return '<div class="cart-item">' +
        '<img class="cart-item__img" src="' + img + '" alt="">' +
        '<div>' +
          '<div class="cart-item__name">' + it.product_title + '</div>' +
          '<div class="cart-item__meta">' + money(it.final_price) + variant + '</div>' +
          '<div class="cart-item__qty">' +
            '<button data-act="dec" data-key="' + it.key + '" data-qty="' + it.quantity + '">−</button>' +
            '<span>' + it.quantity + '</span>' +
            '<button data-act="inc" data-key="' + it.key + '" data-qty="' + it.quantity + '">+</button>' +
          '</div>' +
        '</div>' +
        '<div style="text-align:right">' +
          '<div class="cart-item__price">' + money(it.final_line_price) + '</div>' +
          '<button class="cart-item__rm" data-act="rm" data-key="' + it.key + '">Quitar</button>' +
        '</div>' +
      '</div>';
    }).join("");

    if (foot) {
      foot.style.display = "block";
      var sub = el("cartSub");
      if (sub) sub.textContent = money(cart.total_price);
    }

    $all("[data-act]", list).forEach(function (b) {
      b.addEventListener("click", function () {
        var key = b.getAttribute("data-key");
        var act = b.getAttribute("data-act");
        var q = parseInt(b.getAttribute("data-qty"), 10) || 0;
        if (act === "inc") changeQty(key, q + 1);
        else if (act === "dec") changeQty(key, Math.max(0, q - 1));
        else if (act === "rm") changeQty(key, 0);
      });
    });
  }

  function fetchCart() {
    return fetch("/cart.js", { headers: { "Accept": "application/json" } })
      .then(function (r) { return r.json(); })
      .then(renderCart);
  }

  function changeQty(key, qty) {
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

  function addToCart(id, qty) {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: id, quantity: qty || 1 })
    }).then(function (r) { return r.json(); }).then(function () {
      return fetchCart();
    }).then(function () { openCart(); });
  }

  /* ---------- wiring ---------- */
  function boot() {
    $all("[data-open-cart]").forEach(function (b) {
      b.addEventListener("click", function (e) { e.preventDefault(); openCart(); });
    });
    var close = el("cartClose"), scrim = el("cartScrim");
    if (close) close.addEventListener("click", closeCart);
    if (scrim) scrim.addEventListener("click", closeCart);

    var checkout = document.querySelector(".cart__checkout");
    if (checkout) checkout.addEventListener("click", function () { window.location.href = "/checkout"; });

    // product add-to-cart form (AJAX)
    var form = el("siatraAddForm");
    if (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var idEl = form.querySelector("[name=id]");
        var qtyEl = form.querySelector("[name=quantity]");
        addToCart(idEl ? idEl.value : null, qtyEl ? parseInt(qtyEl.value, 10) : 1);
      });
    }

    // only hit network if cart chrome is present
    if (el("cartList")) fetchCart();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();

  window.SiatraCart = { open: openCart, add: addToCart, refresh: fetchCart };
})();
